import { cn } from 'cn';

import { resolveMessageDisplayText } from '@/shared-question-model';

type Props = {
  text: string;
  className?: string;
};

export const ProjectResponseQuestionText = ({ text, className }: Props) => {
  return (
    <div
      data-test='primary-question-title'
      className={cn(
        'text-center [font-family:var(--brand-font)] text-base font-semibold text-wrap text-(--brand-text-on-bg-image) sm:text-lg',
        className
      )}
    >
      {resolveMessageDisplayText(text)}
    </div>
  );
};
